import axiosInstance from "../../axios";
import { GET_ASSET_INVENTORY, FETCH_ASSET_TYPES_REQUEST } from "../types/assetInventory";

import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

import { alertSuccess } from "../../utils/feedback";
import { claimOrgScopedRequest } from "./orgScopedRequest";

export const setAssetInventory = (assetInventory) => ({
  type: GET_ASSET_INVENTORY,
  payload: assetInventory,
});

export const fetchAssetTypes = (assetTypes) => ({
  type: FETCH_ASSET_TYPES_REQUEST,
  payload: assetTypes,
});

export const fetchAssetInventory = (orgaId) => {
  return async (dispatch) => {
    const isCurrent = claimOrgScopedRequest("asset_inventory");
    dispatch(requestStarted());
    // Dropped before the request leaves - see orgScopedRequest.
    dispatch(setAssetInventory([]));
    try {
      const response = await axiosInstance.get(
        `/survey/assets_inventory/${orgaId}`
      );
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      dispatch(setAssetInventory(response?.data.assets_discovery));
      dispatch(requestSucceeded());
    } catch (error) {
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export function assetTypeList(assetId, orgaId) {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Fetching asset types"));
      const res = await axiosInstance.get(
        `/survey/fetch-asset-types/${assetId}/${orgaId}`
      );
      const assetTypes = res.data;
      console.log("Asset Types:", assetTypes);
      dispatch(fetchAssetTypes(assetTypes)); 
      dispatch(requestSucceeded());
      return assetTypes;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      return null;
    }
  };
}

export function updateDiscoveredAssets(orgaId, data) {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Updating_discovered_assets"));
      const res = await axiosInstance.post(`/survey/discovered_assets_ops`, {
        orga_id: Number(orgaId),
        ops: data,
      });
      const updatedDiscoveredAssets = res.data;
      dispatch(fetchAssetInventory(orgaId));
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      return updatedDiscoveredAssets;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      // Handle error if needed
    }
  };
}

